module.exports = __webpack_public_path__ + "static/img/RS2266_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS2266_1.png
// module id = F6Xh
// module chunks = 0